import React from 'react';

const Card = ({children}) => {

    return <div className={`w-full p-5 rounded-xl surface-1 surface-outline`}>
        {children}
    </div>
}

export default Card;
